module.exports = __webpack_public_path__ + "static/media/October_2026_2.645efd3d.webp";